import { render, staticRenderFns } from "./G_080_KojoDekidakaEntry.vue?vue&type=template&id=1e52050f&scoped=true&"
import script from "./G_080_KojoDekidakaEntry.vue?vue&type=script&lang=ts&"
export * from "./G_080_KojoDekidakaEntry.vue?vue&type=script&lang=ts&"
import style0 from "./G_080_KojoDekidakaEntry.vue?vue&type=style&index=0&id=1e52050f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e52050f",
  null
  
)

export default component.exports